import { render, staticRenderFns } from "./exerciseResult.vue?vue&type=template&id=54977119&scoped=true"
import script from "./exerciseResult.vue?vue&type=script&lang=js"
export * from "./exerciseResult.vue?vue&type=script&lang=js"
import style0 from "./exerciseResult.vue?vue&type=style&index=0&id=54977119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54977119",
  null
  
)

export default component.exports